
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-done_all",
  "use": "icon-material-done_all-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-done_all\"><path d=\"M294.24-230.52 64.5-460.26 113-509l181 181 48.74 48.74zM464-236.26 234.02-466.48l48.98-48.5 181 181L847.76-717.5l48.98 48.5zm0-175.98-48.5-48.74 257-257 48.5 48.74z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-done_all"/>
                </svg>
            );
        };

        Icon.id = "icon-material-done_all";

        export default Icon;
    